import type { IAuthSDK } from '~/shared/api/base-client/AuthSDK';
import { MagnitIdClient } from '../MagnitIdClient';
import type { IGetProfileResponse, IRegisterProfileRequest, IRegisterProfileResponse, IUpdateProfileRequest, IUpdateProfileResponse  } from './models';

export class UserService extends MagnitIdClient {
  constructor(authSDK: IAuthSDK) {
    super({ authSDK });
  }

  public async getProfile(): Promise<IGetProfileResponse> {
    return await this.get('profile', {
      headers: {
        'x-device-tag': await this.getKasperskyDeviceTag(),
      }
    });
  }

  public async updateProfile(profile: IUpdateProfileRequest): Promise<IUpdateProfileResponse> {
    return await this.patch('profile', profile, {
      headers: {
        'x-device-tag': await this.getKasperskyDeviceTag(),
      }
    });
  }

  public async registerProfile(params: IRegisterProfileRequest): Promise<IRegisterProfileResponse> {
    return await this.post('profile/register/magnit-id-code', params, {
      headers: {
        'x-device-tag': await this.getKasperskyDeviceTag(),
      }
    });
  }
}